import { render, staticRenderFns } from "./attr-hotsetting.vue?vue&type=template&id=687755a4&scoped=true&"
import script from "./attr-hotsetting.vue?vue&type=script&lang=js&"
export * from "./attr-hotsetting.vue?vue&type=script&lang=js&"
import style0 from "./attr-hotsetting.vue?vue&type=style&index=0&id=687755a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687755a4",
  null
  
)

export default component.exports